import { NaniumObject, RequestType, Type } from 'nanium/objects';
import { ServiceRequestBase } from '../serviceRequestBase';
import { Application } from './application.contractpart';

export class ApplicationGetRequestBody extends NaniumObject<ApplicationGetRequestBody> {
	@Type(String) applicationId: string;
}

@RequestType({
	responseType: Application,
	genericTypes: { TRequestBody: ApplicationGetRequestBody },
	scope: 'public'
})
export class ApplicationGetRequest extends ServiceRequestBase<ApplicationGetRequestBody, Application> {
	static serviceName: string = 'EduApplication:application/get';
}
